import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../App';

// Where the admin app lives. On a casino's own server it is not app.ezpacetms.com.
// Empty (set by the on-property build) means the same server: /forgot-password.
const ADMIN_URL = process.env.REACT_APP_ADMIN_URL ?? 'https://app.ezpacetms.com';

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#1a1a2e',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    gap: '24px',
  },
  topSection: {
    width: '100%',
    maxWidth: '400px',
  },
  bottomSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    color: '#e94560',
    fontSize: '36px',
    fontWeight: 'bold',
    letterSpacing: '2px',
    textAlign: 'center',
  },
  subtitle: {
    color: '#a0a0b0',
    fontSize: '14px',
    letterSpacing: '1px',
    textAlign: 'center',
    marginTop: '8px',
  },
  card: {
    backgroundColor: '#16213e',
    borderRadius: '16px',
    padding: '32px 24px',
    width: '100%',
    boxSizing: 'border-box',
  },
  label: {
    color: '#a0a0b0',
    fontSize: '13px',
    marginBottom: '8px',
    display: 'block',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  input: {
    width: '100%',
    padding: '16px',
    backgroundColor: '#0f3460',
    border: '1px solid #0f3460',
    borderRadius: '10px',
    color: '#ffffff',
    fontSize: '16px',
    marginBottom: '20px',
    boxSizing: 'border-box',
    outline: 'none',
  },
  button: {
    width: '100%',
    padding: '18px',
    backgroundColor: '#e94560',
    border: 'none',
    borderRadius: '10px',
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '8px',
    boxSizing: 'border-box',
  },
  error: {
    color: '#e94560',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center',
  },
};

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleLogin() {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError('Invalid email or password');
      } else {
        localStorage.setItem('token', data.token);
        localStorage.setItem('name', data.name);
        localStorage.setItem('role', data.role);
        navigate('/select-dealer');
      }
    } catch (e) {
      setError('Could not connect to server');
    }
    setLoading(false);
  }

  return (
    <div style={styles.container}>
      <div style={styles.topSection}>
        <div style={styles.card}>
          {error && <div style={styles.error}>{error}</div>}
          <label style={styles.label}>Email</label>
          <input
            style={styles.input}
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="your@email.com"
            autoCapitalize="none"
          />
          <label style={styles.label}>Password</label>
          <input
            style={styles.input}
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="••••••••"
          />
          <button
            style={styles.button}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>

          <a
            href={`${ADMIN_URL}/forgot-password`}
            style={{ display: 'block', textAlign: 'center', color: '#a0a0b0', fontSize: '14px', marginTop: '18px' }}
          >
            Forgot your password?
          </a>
        </div>
      </div>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        padding: '20px 24px',
        marginBottom: '32px',
        width: '300px',
      }}>
        <img src="/logo.png" alt="EZ Pace" style={{ width: '100%', display: 'block' }} />
      </div>
      </div>
  );
}

export default Login;